import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" aria-hidden="true">
    <path
      d="M5 27C13 23 9 11 19 6.5 24 4.2 28.5 8 26 13.5"
      stroke="#C8A96B"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M24.5 17.5c.5 3 2.5 5 5.5 5.5-3 .5-5 2.5-5.5 5.5-.5-3-2.5-5-5.5-5.5 3-.5 5-2.5 5.5-5.5z"
      fill="#C8A96B"
    />
  </svg>
);

export default function Logo({ dark = false, compact = false }) {
  return (
    <Link
      to="/"
      data-testid="logo-link"
      className="group flex items-center gap-3"
      aria-label="Glow & Blow Unisex Salon — home"
    >
      <LogoMark
        className={`${compact ? "h-7 w-7" : "h-9 w-9"} transition-transform duration-500 group-hover:rotate-6`}
      />
      <span className="leading-none">
        <span
          className={`block font-display font-semibold tracking-[0.08em] ${
            compact ? "text-lg" : "text-xl md:text-2xl"
          } ${dark ? "text-ivory" : "text-ink"}`}
        >
          GLOW <span className="italic text-champagne">&</span> BLOW
        </span>
        {!compact && (
          <span
            className={`mt-1 block text-[9px] font-semibold uppercase tracking-[0.42em] md:text-[10px] ${
              dark ? "text-ivory/60" : "text-taupe"
            }`}
          >
            Unisex Salon
          </span>
        )}
      </span>
    </Link>
  );
}
